import React from "react";
import FormProgress from "../UnitAdmin/FormProgress";
import VersioningGapAssesmentAccordion from "./VersioningGapAssesmentAccordion";

const VersioningGapAssesment = () => {
  return (
    <>
      <div className="addendum-main-container">
        <FormProgress />
        <div className="addendum-heading">Mars QMS - QMS Gap Assessment</div>
        <VersioningGapAssesmentAccordion />
      </div>
    </>
  );
};

export default VersioningGapAssesment;
